module.exports = __webpack_public_path__ + "static/img/来访-1.16c89216.png";